import React, {useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import '../css/dataEntry.css';
import InfoPanel from "../components/pages-component/infoPanel"; 

const DetailsPage = () => {
    const location = useLocation();
    const { infoPanel } = location.state;
    
    return (
        <div>
            <InfoPanel title={infoPanel.title} description={infoPanel.description} />
        </div>
    );
};

export default DetailsPage;
